/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitResolutionRequestScope } from './MonitResolutionRequestScope';
import {
    MonitResolutionRequestScopeFromJSON,
    MonitResolutionRequestScopeFromJSONTyped,
    MonitResolutionRequestScopeToJSON,
} from './MonitResolutionRequestScope';

/**
 * 
 * @export
 * @interface MonitDeleteEntityFindingResolutionsQueries
 */
export interface MonitDeleteEntityFindingResolutionsQueries {
    /**
     * 
     * @type {MonitResolutionRequestScope}
     * @memberof MonitDeleteEntityFindingResolutionsQueries
     */
    scope?: MonitResolutionRequestScope;
}

/**
 * Check if a given object implements the MonitDeleteEntityFindingResolutionsQueries interface.
 */
export function instanceOfMonitDeleteEntityFindingResolutionsQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitDeleteEntityFindingResolutionsQueriesFromJSON(json: any): MonitDeleteEntityFindingResolutionsQueries {
    return MonitDeleteEntityFindingResolutionsQueriesFromJSONTyped(json, false);
}

export function MonitDeleteEntityFindingResolutionsQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitDeleteEntityFindingResolutionsQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scope': !exists(json, 'scope') ? undefined : MonitResolutionRequestScopeFromJSON(json['scope']),
    };
}

export function MonitDeleteEntityFindingResolutionsQueriesToJSON(value?: MonitDeleteEntityFindingResolutionsQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'scope': MonitResolutionRequestScopeToJSON(value.scope),
    };
}

